export const carouselConfigJson = {
  playlistConfig: {
    tabType: 'playlist',
    playlistID: '2222',
    showBottomThumbnails: false,
    showAllVideosButton: true,
    allVideosButtonLabel: 'All videos',
    allVideosButtonUrl: 'https://allvideourl.com',
    nextVideoSuggested: false,
    nextVideoPlaylist: true,
    audiooff: false,
    autoplay: true,
    tabTitle: 'Tab 2',
    singleVideoType: false,
    liveType: false,
    playlistType: true,
    sectionsType: false,
    tagsType: false,
  },
  tagsConfig: {
    tabType: 'tags',
    singleVideoID: '111111',
    playlistID: '222',
    tags: ['sport', 'calcio', 'champions league'],
    showBottomThumbnails: true,
    showAllVideosButton: false,
    nextVideoSuggested: false,
    nextVideoPlaylist: false,
    audiooff: false,
    autoplay: false,
    tabTitle: 'Tab 4',
    singleVideoType: false,
    liveType: false,
    playlistType: false,
    sectionsType: false,
    tagsType: true,
  },
  sectionsConfig: {
    tabType: 'sections',
    playlistID: 'hhhgfhgfhgf',
    sectionID: 'sport',
    subSectionID: 'calcio',
    subSubSectionID: 'champions-league',
    showBottomThumbnails: false,
    showAllVideosButton: false,
    nextVideoSuggested: false,
    nextVideoPlaylist: false,
    audiooff: false,
    autoplay: false,
    tabTitle: 'Tab 5',
    singleVideoType: false,
    liveType: false,
    playlistType: false,
    sectionsType: true,
    tagsType: false,
  },
};
